// extracted by mini-css-extract-plugin
export default {"WeatherStatCard":"WeatherStatCard_WeatherStatCard__qkASQ"};